import { defineMessages } from 'react-intl'

const translations = defineMessages({
  MR: {
    defaultMessage: 'Mr',
    id: 'msp.address_form.salutation.mr'
  },
  MRS: {
    defaultMessage: 'Mrs',
    id: 'msp.address_form.salutation.mrs'
  },
  _: {
    defaultMessage: ' ',
    id: 'msp.address_form.salutation.none'
  }
})

export default translations
